import { ElementRef, Injectable } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BehaviorSubject, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CommonConstants } from '../utilities/commonConstants';
import { SessionHandlerService } from './sessionHandler.service';
import { RouteContextProvider } from './routeContextProvider.service';
import { CookieHandlerService } from './cookieHandler.service';
import { DialogService } from '../components/dialog/dialog.service';
import { CommonErrorMessageDrawerComponent } from '../components/dialog/common-error-message-drawer/common-error-message-drawer.component';
import { DialogRef } from '../components/dialog/dialog-ref';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  public _sharingData = {};
  public themeChange = new Subject();
  public theme: string;
  private appDrawerNotify$: BehaviorSubject<any> = new BehaviorSubject<any>(false);
  private otpTimerNotify$: BehaviorSubject<any> = new BehaviorSubject<any>(false);
  private loaderNotify$: BehaviorSubject<any> = new BehaviorSubject<any>(false);
  private applicationCreateNotify$: BehaviorSubject<any> = new BehaviorSubject<any>(false);
  private commonDrawerNotify$: BehaviorSubject<any> = new BehaviorSubject<any>(false);
  private isKnowMoreDrawerOpen = new BehaviorSubject<boolean>(false);
  isKnowMoreDrawerOpen$ = this.isKnowMoreDrawerOpen.asObservable(); B

  constructor(
    private _sessionHandler: SessionHandlerService,
    private _routeContextProvider: RouteContextProvider,
    private _cookieHandlerService: CookieHandlerService,
    private dialogService: DialogService,
    private dialogRef: DialogRef,
    private router: Router
  ) { }
  
  setKnowMoreDrawerState(isOpen: boolean) {
    this.isKnowMoreDrawerOpen.next(isOpen);
  }


  public setData(prop: string, value: any) {
    // internally mutate our state
    this._sharingData[prop] = value;
  }
  public getData(prop?: any) {
    // use our state getter for the clone
    const data = this._sharingData;
    return data.hasOwnProperty(prop) ? data[prop] : ''; // data;
  }
  public isBFLJourney() {
    let bflJourney = environment['bflenvironment'];
    return bflJourney && bflJourney !== undefined ? true : false;
  }
  public getPackagePremium(summary) {
    let netValue;
    if (summary && summary.premiumFareBreakup) {
      summary.premiumFareBreakup.forEach(element => {
        if (element.headerName === "Premium Details") {
          netValue = element.premiumSummaryDetails.find(ele => {
            if (ele.paramdesc === "Package Premium") {
              return ele.net;
            }
          });
        }
      });
      return netValue ? netValue.net : '';
    }
  }

  public getVehicleType() {
    // let vehicleType = this.getData(CommonConstants.QueryParamsKeys.InsuranceProductType).toString() ?
    //   this.getData(CommonConstants.QueryParamsKeys.InsuranceProductType).toString() :
    //   this._sessionHandler.GetSession(CommonConstants.CookieKeys.InsProductType);
    let vehicleType = 'FWGI';
    let InsProductType = 'FWGI';
    let url: any = window.location.pathname;
    if (!vehicleType) {
      // InsProductType = url.includes('car-insurance') ? 'FWGI' : url.includes('two-wheeler-insurance')
      //   ? 'TWGI' : url.includes('taxi-car-insurance-calculator') ? 'TXGI' :
      //     url.includes('commercial-vehicle-insurance-calculator') ? 'CVGI' : 'FWGI';
      this.setData(CommonConstants.QueryParamsKeys.InsuranceProductType,
        InsProductType);
      this._sessionHandler.SetSession(CommonConstants.CookieKeys.InsProductType, InsProductType);
      vehicleType = InsProductType;
    }
    return vehicleType;
  }


  public isMobile() {
    return this._routeContextProvider.GetQueryParams('isMobile') || '';
  }

  public clearCookie() {
    let LoanApplicationId = this._sessionHandler.GetSession(CommonConstants.CookieKeys.LoanApplicationId);
    if (LoanApplicationId) {
      this._cookieHandlerService.DeleteCookies([CommonConstants.CookieKeys.LoanApplicationId], LoanApplicationId);
    }
    this._cookieHandlerService.DeleteCookies([CommonConstants.CookieKeys.userMob, CommonConstants.CookieKeys.authtoken]);
  }

  public UtmStamping() {
    let visitorID = null;
    setTimeout(() => {
      if (window['_satellite']) {
        const _satellite: any = Object.keys(window['_satellite']).length;
        if (_satellite && _satellite.length !== 0) {
          visitorID = window['_satellite']['getVisitorId']()['getMarketingCloudVisitorID']();
        }
      }
    }, 5000);
    let UTM: any = this._sessionHandler.GetSession('UTM');
    const UtmType = this._sessionHandler.GetSession('UtmType');
    let campaignCookie: any;
    try {
      campaignCookie = this._cookieHandlerService.GetCookie('campaignCookie') ? JSON.parse(this._cookieHandlerService.GetCookie('campaignCookie')) : null;
    }
    catch (error) {
      campaignCookie = this._cookieHandlerService.GetCookie('campaignCookie');
    }
    const source = this._routeContextProvider.GetQueryParams('utm_source') ? this._routeContextProvider.GetQueryParams('utm_source') : this._routeContextProvider.GetQueryParams('utmSource');
    const medium = this._routeContextProvider.GetQueryParams('utm_medium');
    const campaign = this._routeContextProvider.GetQueryParams('utm_campaign');
    const content = this._routeContextProvider.GetQueryParams('utm_content');
    const term = this._routeContextProvider.GetQueryParams('utm_term');
    UTM = UTM.split(':');
    if (UTM.length === 1) { UTM.length = []; }
    const sourcing = {
      'utmSource': UTM.length ? UTM[1] : source ? source : campaignCookie?.utm_source ? campaignCookie?.utm_source : CommonConstants.utmSource.organic,
      'utmMedium': UTM.length ? UTM[2] || '' : medium ? medium : campaignCookie?.utm_medium ? campaignCookie?.utm_medium : null,
      'utmCampaign': UTM.length ? UTM[3] || '' : campaign ? campaign : campaignCookie?.utm_campaign ? campaignCookie?.utm_campaign : null,
      'utmContent': UTM.length ? UTM[4] || '' : content ? content : campaignCookie?.utm_content ? campaignCookie?.utm_content : null,
      'utmTerm': UTM.length ? UTM[5] || '' : term ? term : campaignCookie?.utm_term ? campaignCookie?.utm_term : null,
      'gclId': visitorID ? visitorID : null,
      'recVersion': 1
    };
    return sourcing;
  }
  // Session Management for reading session from widget


 

  public openCommonErrorDialog(drawerName: string, errorMessage: string, drawerTitle?: string, displayImage?: boolean) {
    this.dialogRef = this.dialogService.open(CommonErrorMessageDrawerComponent, {
      data: {
        title: drawerTitle,
        desc: errorMessage,
        displayImage: displayImage || false
      },
      panelClass: drawerName,
      hasBackdrop: true,
      disableClose: true,
      showMinimizedButton: true,
      closeOnOutsideClick: false
    });
    this.dialogRef.afterClosed.subscribe(result => {
      this._sessionHandler.DeleteSession(
        [CommonConstants.CookieKeys.LoanApplicationId, CommonConstants.CookieKeys.processId, CommonConstants.CookieKeys.PlanQuoteIds]
      );
      this.router.navigate(['vehicleRegistration']);
    });
  }

  // Vehicle registration validation functionality
  validateInput(c: FormControl) {
    let validStatus = (CommonConstants.vehicleRegistrationPattern.pattern.test(c.value) || CommonConstants.vehicleRegistrationPattern.bhSeriesPattern.test(c.value)) ? null : {
        pattern: {
          valid: false
        }
    };
    if (c.value) {
      return validStatus;
    } else {
      return null;
    }
  }

  // Session Management for reading session from widget
  setWidgetInformation(param: any) {
    if (param.src === 'widget') {
      console.log('redirected from widget');
      this.setSessionVariables(param);
      /* We need to remove query params sent by EP.
      As we read values from URL on vehicle details and PLP page. If user goes back to get quote page and
      creates new application, new values will not get picked from session */
      setTimeout(() => {
        this._routeContextProvider.removeQueryParams();
      }, 1000);
    }
  }

  setSessionVariables(param: any) {
    const paramKeys = Object.keys(param);
    paramKeys.forEach((key: string) => {
      sessionStorage.setItem(key, param[key]);
    });
  }


  public onExplore(redirectionKey: string, redirectionValue: string) {
    const platform = this._sessionHandler.GetSession(CommonConstants.CookieKeys.platform);
    const redirectionUrl = `inssdk://applaunch?redirection_key=${redirectionKey}&Redirection_value=${redirectionValue}`;
    if (platform.toLowerCase() === CommonConstants.platforms.ios) {
      window.open(redirectionUrl, '_self');
    } else if (platform.toLowerCase() === CommonConstants.platforms.android) {
      window.open(redirectionUrl, '_self');
    } else {
      window.open(CommonConstants.bflHomePageUrl, '_blank');
    }
  }
  

}
